// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateSearchByDropDown = key => ({
    key,
    type: actions.UPDATE_CLAIM_SEARCH_BY
});




// WEBPACK FOOTER //
// ./src/claim/shared/action-creators/search-by-dropdown.js